/* eslint-disable prefer-arrow-callback */
import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { LoadingButton } from '@mui/lab';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AlertDialogSlide({ dialogTitle, dialog, isOpen, onClose, onOption, loading }) {
  return (
    <div>
      <Dialog
        open={isOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={onClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{dialogTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">{dialog}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => onOption(false)}>Cancel</Button>
          <LoadingButton loading={loading} onClick={() => onOption(true)}>
            Yes, Continue
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </div>
  );
}
